import React, { SVGProps } from "react";

export default function GovernmentsIcon({ color, ...props }: SVGProps<any>) {
  return (
    <svg viewBox="0 0 26 26" width={26} height={26} {...props}>
      <g fill="none" fillRule="evenodd" stroke={color} strokeLinecap="round" strokeLinejoin="round">
        <path
          strokeWidth={1.573}
          d="M22.564 24.744H3.692c-1.301 0-2.359-.704-2.359-1.573V9.2a1.36 1.36 0 01.66-1.092l9.586-6.617a3.708 3.708 0 013.098 0l9.586 6.617c.388.232.635.641.66 1.093V23.17c0 .869-1.058 1.573-2.359 1.573z"
        />
        <path d="M6.718 12.436v11.282zm4.102 0v11.282zm4.103 0v11.282zm4.103 0v11.282z" strokeWidth={2.64} />
      </g>
    </svg>
  );
}
